// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"89":"55f8a5df","126":"9d5556dc","174":"4ee3e04c","309":"9555f368","323":"cffea8e1","384":"9b04eee5","401":"da6b967d","416":"d96b08d6","417":"3609c517","503":"0a25f4fc","725":"ffa45805"}[chunkId] + ".chunk.js";
};